module.exports = __webpack_public_path__ + "img/icon_vod_link_w.0291da94.svg";